import * as moment from 'moment';

export class PagedHistoryRequest {

	public pageNumber: number;
	public pageSize: number;
	public startDate: any;
	public endDate: any;
	public transactionType?: any;
	public amount?: any;

	constructor(obj?: any) {
		this.pageNumber = obj && obj.pageNumber || 1;
		this.pageSize = obj && obj.pageSize || 10;
		this.startDate = obj && obj.startDate && moment(obj.startDate).format('YYYY-MM-DD')
			|| moment().subtract(11, 'months').format('YYYY-MM-DD');
		this.endDate = obj && obj.startDate && moment(obj.endDate).format('YYYY-MM-DD')
			|| moment().format('YYYY-MM-DD');
	}
}


